import { createContext } from 'react';
import { Experiment } from '../../types';

export interface ExperimentData {
  experiments: Experiment[];
}

const initialContext: ExperimentData = {
  experiments: []
};

export default createContext<ExperimentData>(initialContext);
